<h1 mat-dialog-title>{{ isEdit ? 'Konto bearbeiten' : 'Konto anlegen' }}</h1>
<div mat-dialog-content class="dialog-content">
    <mat-form-field appearance="outline" class="full">
        <mat-label>Konto-Nr.</mat-label>
        <input matInput [formControl]="kontoNrCtrl" (blur)="onKontoNrBlur()" required />
        <mat-hint>z.B. 4530.42 oder 901030</mat-hint>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full">
        <mat-label>Bezeichnung</mat-label>
        <input matInput [formControl]="bezeichnungCtrl" required />
    </mat-form-field>

    <mat-form-field appearance="outline" class="full">
        <mat-label>BWA-Gruppe</mat-label>
        <mat-select [formControl]="bwaGruppeCtrl" [compareWith]="compareId">
            <mat-option [value]="null">Keine Zuordnung</mat-option>
            <mat-option *ngFor="let g of bwaGruppen" [value]="g.bwa_gruppe_id">{{ g.bezeichnung }}</mat-option>
        </mat-select>
        <mat-hint>Wird aus der Kontonummer vorgeschlagen, kann überschrieben werden</mat-hint>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full">
        <mat-label>Kontotyp</mat-label>
        <mat-select [formControl]="kontoTypCtrl" [compareWith]="compareId">
            <mat-option *ngFor="let t of typen" [value]="t.value">{{ t.label }}</mat-option>
        </mat-select>
    </mat-form-field>

    <div class="row">
        <mat-form-field appearance="outline" class="half">
            <mat-label>Sachkonto</mat-label>
            <input matInput [formControl]="sachkontoCtrl" />
        </mat-form-field>
        <mat-form-field appearance="outline" class="half">
            <mat-label>Suffix</mat-label>
            <input matInput [formControl]="suffixCtrl" />
        </mat-form-field>
    </div>

    <mat-checkbox [formControl]="aktivCtrl">Aktiv</mat-checkbox>

    <mat-form-field appearance="outline" class="full">
        <mat-label>Kommentar</mat-label>
        <textarea matInput [formControl]="kommentarCtrl" rows="2"></textarea>
    </mat-form-field>
</div>
<div mat-dialog-actions align="end">
    <button mat-button type="button" (click)="close()">Abbrechen</button>
    <button mat-flat-button color="accent" type="button" [disabled]="!isValid()" (click)="save()">
        Speichern
    </button>
</div>
